// extracted by mini-css-extract-plugin
module.exports = {"item":"_1Q2CHR17VLtIBNfmxyMlgT","icon":"_2bN4jWlNUs37FEPmW_FY7V","name":"ejLr6_f2WmzQHup_CdZPF","arrow":"_2_3HnY7OIA3vPxjM8E3tzy"};